/* istanbul ignore file */
import fetch from '../Http/fetch';

export default class BreadcrumbApi {
    static async add(payload) {
        return fetch('/_breadcrumbs', { method: 'POST', body: JSON.stringify(payload) });
    }
}
